import { toast } from "sonner";

// Contact details step (shown first).
export const validateContact = (form) => {
    const required = [
        form.company_size,
        form.name.trim(),
        form.email.trim(),
        form.company_name.trim(),
        form.contact_number.trim(),
    ];
    if (required.some((value) => !value)) {
        toast.error("Please complete all required fields.");
        return false;
    }
    return true;
};

// Optimisation brief step (shown second).
export const validateBrief = (form) => {
    if (!form.pain_point) {
        toast.error("Select a primary pain point.");
        return false;
    }
    if (!form.bottleneck.trim()) {
        toast.error("Describe your operational bottleneck.");
        return false;
    }
    return true;
};
